import { Component } from "react";
import {
    View,
    TouchableOpacity,
    Image,
    Dimensions,
    ScrollView,
    FlatList,
    Platform,
    BackHandler,
    Text
} from "react-native";
import Slideshow from "../components/react-native-slideshow";
// import ActionSheet from 'react-native-actionsheet';
import * as Styles from "../utils/Styles";
import * as AppStyles from "../utils/appStyles";
import * as Commons from "../utils/Commons";
import { STRINGS } from "../utils/Strings";
import * as Constants from "../utils/Constants";
import * as ServerOperations from "../utils/ServerOperations";
import FeaturedItem from "../components/FeaturedItem";
import OrderDetails from "./OrderDetails";
import ProductDetails from "./ProductDetails";
import CheckOut from "./CheckOut";
import OrderNow from "./OrderNow";
let height = Dimensions.get("window").height;
let width = Commons.getWidth();
let styles = {};
let scale = 1;
let isMobile = false;
let filterName = [];
const rightArrow = require("../images/home/rightArrow.png");
const giftIcon = require("../images/orderNow/gift.png");
const truckIcon = require("../images/Shop/Truck.png");
const arrowUp = require("../images/Shop/ArrowUp.png");
const arrowDown = require("../images/Shop/arrowDown.png");

class Shop extends Component {
    constructor(props) {
        super(props);

        this.state = {
            advs: [],
            categories: [],
            offers: [],
            brands: [],
            products: [],
            consumerBrands: [],
            featuredItems: [],
            bestSellers: [],
            joImgPos: 0,
            advImgPos: 0,
            showCheckout: false,
            showProductsDetails: false,
            productID: '',
            featuredQty: 0,
            showOrderNow: false,
            filterID: '',
            isOffers: false,
            filterName: [],
            categoryFilter: '',
            itemsNo: 0,
            isBestSellers: false,
            isOther: false,
            allFilters: [],
            showOffersAndBestSellers: false,
            searchText: '',
            isSearch: false,
            searched: false,
            orderResponse: [],
            updatedItem: [],
            isFeatured: false,
            isAdv: false,
            isAdvProducts: [],
            currentAdvIndex: 0,
            scrollDirection: 1, // 1 for forward, -1 for backward
            showActiveOrder: false,
            orders: [],
            showOrderDetails: false,
            showFilters: false,
            searchText: ''
        };

        this.autoScrollInterval = null;
    }
    Pressables = {};

    async componentDidMount() {
        if (typeof window !== 'undefined' && window.addEventListener && this.props.showOrderNow) {
            window.addEventListener('popstate', this.handleBackButton);

            // Push current state to history for better navigation
            const currentState = {
                page: 'Shop',
                timestamp: Date.now()
            };
            window.history.pushState(currentState, 'Shop', window.location.pathname);
        }

        // Add Android back button handler
        if (Platform.OS === 'android') {
            this.backHandler = BackHandler.addEventListener('hardwareBackPress', this.handleAndroidBackButton);
        }

        if (this.props.self) {
            this.props.self.shop = this;
        }

        this.loadData();
    }

    componentWillUnmount() {
        // Clean up event listener
        if (typeof window !== 'undefined' && window.removeEventListener) {
            window.removeEventListener('popstate', this.handleBackButton);
        }

        // Remove Android back button handler
        if (Platform.OS === 'android' && this.backHandler) {
            this.backHandler.remove();
        }
    }


    handleBackButton = (event) => {
        // Handle back button press - close product details
        // Prevent default browser back behavior if needed
        // You can remove this if you want normal browser back behavior
        if (event.state && event.state.page === 'Shop') {
            // Custom handling - stay on current page but close modal/details
            window.history.pushState(event.state, 'Shop', window.location.pathname);
        }
    }

    handleAndroidBackButton = () => {
        // Handle Android back button
        // Close modals/overlays in order of priority
        if (this.state.showProductsDetails) {
            this.setState({ showProductsDetails: false });
            return true; // Prevent default back action
        }

        if (this.state.showOrderNow) {
            this.setState({
                showOrderNow: false,
                filterID: '',
                isOffers: false,
                isBestSellers: false,
                isFeatured: false,
                isAdv: false,
                featuredItems: this.state.featuredItems.slice(),
                bestSellers: this.state.bestSellers.slice(),
                products: this.state.products.slice(),
                filterName: [],
                categoryFilter: '',
                allFilters: [],
                searchText: ''
            });
            return true; // Prevent default back action
        }

        if (this.state.showCheckout) {
            this.setState({
                showCheckout: false,
                featuredItems: this.state.featuredItems.slice(),
                bestSellers: this.state.bestSellers.slice()
            });
            return true; // Prevent default back action
        }

        if (this.state.showOrderDetails) {
            this.setState({ showOrderDetails: false });
            return true; // Prevent default back action
        }

        if (this.state.isSearch) {
            this.setState({ isSearch: false, searchText: '' });
            return true; // Prevent default back action
        }

        // If we're on the main shop page with no overlays, prevent going back further
        // This keeps the user on the shop page as the root
        return true; // Always prevent default back action to stay on shop page
    }


    loadBasket = async () => {
        const parsedItems = await Commons.getBasketItems();
        try {
            const orderResp = await ServerOperations.calcOrderPrice(parsedItems);
            this.setState({ itemsNo: parsedItems.length, orderResponse: orderResp.ITEMS || [] });
        } catch (e) {
            console.log('Failed to parse ITEMS_IN_BASKET:', e);
            console.log(itemsInBasket);
            this.setState({ itemsNo: 0 });
        }
    }

    loadData = async () => {
        await this.loadBasket();

        ServerOperations.getOrders('', '', '').then(orderResp => {
            this.setState({ orders: orderResp.ORDS });
            console.log('Orders loaded:', orderResp.ORDS);
        }).catch(error => {
            console.log('Error loading orders:', error);
        });

        const advResp = await ServerOperations.getAdvImages();
        this.setState({ advs: advResp });

        const brandsResp = await ServerOperations.getConumerBrands();
        this.setState({ consumerBrands: brandsResp });

        const offersResp = await ServerOperations.getOffers();
        this.setState({ offers: offersResp });

        const catgResp = await ServerOperations.getCategories();
        this.setState({ categories: catgResp });

        const featuredResp = await ServerOperations.getFeaturedItems();
        this.setState({ featuredItems: featuredResp });

        const bestSellersResp = await ServerOperations.getBestSellers();
        this.setState({ bestSellers: bestSellersResp });

        // const orderResp = await ServerOperations.getOrders('', '', '');
        // this.setState({ orders: orderResp.ORDS });
        // console.log('Orders loaded:', orderResp.ORDS);


        const productsResp = await ServerOperations.getProducts('', '', '', '');
        this.setState({ products: productsResp });
    }



    updateCurrentProduct = async (productID) => {
        const itemsInBasket = await Commons.getFromAS(Constants.ITEMS_IN_BASKET);
        try {
            const parsedItems = JSON.parse(itemsInBasket);
            const orderResp = await ServerOperations.calcOrderPrice(parsedItems);
            if (orderResp && Array.isArray(orderResp.ITEMS)) {
                const foundItem = orderResp.ITEMS.find(item => item.ID === productID);
                if (foundItem) {
                    this.setState({ updatedItem: foundItem, [`itemQty${productID}`]: foundItem.qty || 1 });
                } else {
                    console.log('Product not found in ITEMS');
                }
            }
        } catch (e) {
            console.log('Failed to parse ITEMS_IN_BASKET:', e);
            console.log(itemsInBasket);
        }

    }

    renderFeaturedItem = (item) => {
        return (
            // <View style={{ justifyContent: 'center', alignItems: 'center', backgroundColor: '#FFF' }}>
            <FeaturedItem
                self={this}
                item={item}
                orderResponse={this.state.orderResponse}
                itemsNo={(show) => { this.setState({ itemsNo: show }) }}
                isSearch={this.state.isSearch && isMobile}
                showProductsDetails={(show) => {
                    this.setState({ showProductsDetails: show, productID: item.ID });
                }} />
            // </View>
        )
    }

    updateCurrentItem = async () => {
        if (this.state.productID) {
            await this.updateCurrentProduct(this.state.productID);
            this.forceUpdate();
        }
    }



    renderMobile() {
        scale = width / 420;
        return (
            [
                Commons.loadFonts(this, false),
                this.state.showProductsDetails && (
                    <View style={{ position: 'absolute', width, height, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 100 }}>
                        <ProductDetails self={this} productID={this.state.productID}
                            showProductsDetails={
                                async (show) => {
                                    this.setState({ showProductsDetails: show });
                                    const itemsInBasket = await Commons.getFromAS(Constants.ITEMS_IN_BASKET);
                                    try {
                                        const parsedItems = JSON.parse(itemsInBasket);
                                        this.setState({ itemsNo: parsedItems.length });
                                    } catch (e) {
                                        console.log('Failed to parse ITEMS_IN_BASKET:', e);
                                    }
                                }}
                        // updateItem={() => { this.updateFeaturedQty(qty) }}
                        // onUpdate={() => { this.updateCurrentItem() }} 
                        />
                    </View>
                )
                ,
                <View style={styles.container}>
                    {Commons.renderAppHeader('', this, '',
                        this.state.products, this.state.products, this.state.isSearch, this.state.searched, this.state.searchText, this.state.itemsNo)}
                    {this.state.showOrderNow && !this.state.isSearch && (
                        <View style={{ position: 'absolute', height: height - (Platform.OS === 'web' ? 0 : 20), zIndex: 100 }}>
                            <OrderNow self={this} consumerBrandFilter={this.state.filterID} consumerBrandName={this.state.filterName} isOffers={this.state.isOffers}
                                categoryFilter={this.state.categoryFilter} isBestSellers={this.state.isBestSellers} isFeatured={this.state.isFeatured}
                                allFilters={this.state.allFilters}
                                isAdv={this.state.isAdv}
                                isAdvProducts={this.state.isAdvProducts}
                                searchText={this.state.searchText}
                                navigation={this.props.navigation}
                                showOrderNow={(show) => {
                                    this.setState({
                                        showOrderNow: show, filterID: '', isOffers: show, isBestSellers: show, isFeatured: show, isAdv: show,
                                        featuredItems: this.state.featuredItems.slice(), bestSellers: this.state.bestSellers.slice(),
                                        products: this.state.products.slice(), filterName: [], categoryFilter: '', allFilters: [],
                                    });
                                    if (!show) {
                                        filterName = [];
                                    }
                                }}
                            />
                        </View>
                    )}

                    {this.state.showOrderDetails &&
                        <OrderDetails
                            self={this}
                            OrderNumber={this.state.detailsOrderNo}
                            InvoiceNumber={this.state.detailsOrderInvoice}
                            InvoiceID={this.state.detailsOrderInvoiceID}
                            OrderDate={this.state.detailsOrderDate}
                            InvoiceAmount={this.state.InvoiceValue}
                            showOrderDetails={(show) => { this.setState({ showOrderDetails: show }); }} />
                    }


                    <ScrollView
                        ref={ref => this.mainScrollView = ref}
                        scrollEventThrottle={200} showsVerticalScrollIndicator={false} onScroll={(e) => Commons.onHeaderScroll(e, this)}>

                        {!this.state.isSearch && (
                            <View style={{ width, backgroundColor: AppStyles.desktopBackgroundColor }}>
                                {Styles.renderVSeparator(0)}
                                {this.renderPart1Mobile()}
                                {this.renderPart2Mobile()}
                                {this.renderPart3Mobile()}
                                {this.renderPart4Mobile()}
                                {this.renderPart5Mobile()}
                                {this.renderPart6Mobile()}
                                {this.renderPart7Mobile()}
                            </View>
                        )}
                        {this.state.isSearch && (
                            // Commons.renderSearchView(this)
                            <FlatList
                                style={{ flex: 1 }}
                                ref={ref => { this.productsFlatList = ref; }}
                                data={this.state.products.slice(0, 300)}
                                keyExtractor={(item) => item.ID}
                                renderItem={({ item }) => this.renderFeaturedItem(item)}
                                contentContainerStyle={{ paddingVertical: 8, alignItems: isMobile ? 'center' : 'flex-start', justifyContent: isMobile ? 'center' : 'flex-start' }}
                                numColumns={1}
                                removeClippedSubviews
                                maxToRenderPerBatch={10}
                                windowSize={10}
                                showsVerticalScrollIndicator={false}

                            />
                        )}
                    </ScrollView>

                    {this.state.isOther && Commons.renderOtherView(this, this.state.isOther)}
                    {this.state.isOther && Commons.renderAppFooter({}, this, '', '', '', '#52C0EE')}
                    {!this.state.isOther && Commons.renderAppFooter({}, this, '#52C0EE')}
                </View >
            ]
        );
    }

    checkout() {
        this.setState({ showProductsDetails: false, showOrderNow: false, showCheckout: true });
        // if (this.props.self) {
        //     this.props.self.setState({ style: { opacity: 0.5 } });
        // }
    }

    getPaddedData = (originalData, columns) => {
        if (columns === 1) return originalData; // No padding needed for single column

        const data = [...originalData];
        const remainder = data.length % columns;

        if (remainder !== 0) {
            const itemsToAdd = columns - remainder;
            for (let i = 0; i < itemsToAdd; i++) {
                data.push({
                    ID: `dummy_${i}`,
                    isDummy: true
                });
            }
        }
        return data;
    };


    render() {
        isMobile = Commons.isMobile();
        if (isMobile) {
            Commons.resizeHandle(window, this, () => {
                width = this.width;
                height = this.height;
            });
            width = Dimensions.get("window").width;
            height = Dimensions.get("window").height;
            styles = this.styles();
            return this.renderMobile();
        } else if (window.location.pathname !== '/ClientHomePage') {
            window.location = './ClientHomePage';
            return null;
        }
        const columnNum = Commons.getNumColumns();
        const paddedData = this.state.isSearch ? this.getPaddedData(this.state.products.slice(0, 400), columnNum) : [];

        width = (Commons.getDesktopWidth()) - 50;
        height = Commons.getDesktopHeight();
        styles = this.styles();
        scale = width / 900;
        return (
            [
                this.state.showProductsDetails && (
                    <View style={{ position: 'absolute', flex: 1, minHeight: '100%', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 100 }}>
                        <ProductDetails self={this} productID={this.state.productID}
                            showProductsDetails={
                                async (show) => {
                                    this.setState({ showProductsDetails: show });
                                    const itemsInBasket = await Commons.getFromAS(Constants.ITEMS_IN_BASKET);
                                    try {
                                        const parsedItems = JSON.parse(itemsInBasket);
                                        this.setState({ itemsNo: parsedItems.length });
                                    } catch (e) {
                                        console.log('Failed to parse ITEMS_IN_BASKET:', e);
                                    }
                                    if (!show) {
                                        this.props.self.setState({ style: { opacity: 1 } });
                                    }
                                }}
                            updateItem={() => { this.updateFeaturedQty(qty) }}
                            onUpdate={() => { this.updateCurrentItem() }} />
                    </View>
                ),
                <View style={{ marginLeft: 15, backgroundColor: AppStyles.desktopBackgroundColor, width: width }}>
                    {
                        !this.state.showOrderNow &&
                        Commons.renderAppHeader('', this, true, this.state.products, this.state.products, this.state.isSearch, this.state.searched, this.state.searchText, this.state.itemsNo)
                    }
                </View>,
                this.state.showOrderNow && (
                    <View style={{ position: 'absolute', width: width + 30, height, zIndex: 100 }}>
                        <OrderNow
                            self={this} consumerBrandFilter={this.state.filterID} consumerBrandName={this.state.filterName} isOffers={this.state.isOffers}
                            categoryFilter={this.state.categoryFilter} isBestSellers={this.state.isBestSellers} isFeatured={this.state.isFeatured}
                            products={this.state.products}
                            allFilters={this.state.allFilters}
                            isAdv={this.state.isAdv}
                            isAdvProducts={this.state.isAdvProducts}
                            searchText={this.state.searchText}
                            navigation={this.props.navigation}
                            showOrderNow={(show) => {
                                this.setState({
                                    showOrderNow: show, filterID: '', isOffers: show, isBestSellers: show, isFeatured: show,
                                    featuredItems: this.state.featuredItems.slice(), bestSellers: this.state.bestSellers.slice(),
                                    products: this.state.products.slice(), filterName: [], categoryFilter: '', allFilters: [],
                                    searchText: ''
                                });
                                if (!show) {
                                    this.props.self.setState({ style: { opacity: 1 } });
                                    filterName = [];
                                }
                            }}
                        />
                    </View>
                )
                , this.state.showCheckout && (
                    <View style={{ position: 'absolute', width, height, zIndex: 100, marginLeft: 2.5 }}>
                        <CheckOut self={this}
                            products={this.state.products}
                            showCheckout={(show) => {
                                this.setState({
                                    showCheckout: show,
                                    featuredItems: this.state.featuredItems.slice(),
                                    bestSellers: this.state.bestSellers.slice()
                                });
                                if (!show) {
                                    this.props.self.setState({ style: { opacity: 1 } });
                                }
                            }}
                        />
                    </View>
                )
                ,
                this.state.showOrderDetails && (
                    <OrderDetails
                        self={this}
                        OrderNumber={this.state.detailsOrderNo}
                        InvoiceNumber={this.state.detailsOrderInvoice}
                        InvoiceID={this.state.detailsOrderInvoiceID}
                        OrderDate={this.state.detailsOrderDate}
                        InvoiceAmount={this.state.InvoiceValue}
                        showOrderDetails={(show) => {
                            this.setState({ showOrderDetails: show });
                            this.props.self.setState({ style: { opacity: 1 } });
                        }} />
                ),

                this.state.isSearch && (
                    // Commons.renderSearchView(this)
                    <FlatList
                        style={{ paddingHorizontal: 20, maxHeight: height - 70 }}
                        ref={ref => { this.productsFlatList = ref; }}
                        data={paddedData}
                        keyExtractor={(item, index) => item.isDummy ? `dummy_${index}` : item.ID}
                        renderItem={({ item, index }) => {
                            // if (item.isDummy) {
                            //     return <View style={{ flex: 1 }} />; // Empty placeholder
                            // }
                            return this.renderFeaturedItem(item, index);
                        }}
                        contentContainerStyle={{ paddingVertical: 8 }}
                        numColumns={columnNum}
                        columnWrapperStyle={{ justifyContent: 'space-between' }}
                        key={`flatlist-columns-${columnNum}`}
                        removeClippedSubviews
                        maxToRenderPerBatch={10}
                        windowSize={10}
                        showsVerticalScrollIndicator={false}
                    />
                )
                ,
                !this.state.showOrderDetails && !this.state.isSearch &&
                [
                    // <View style={{
                    //     position: 'absolute',
                    //     top: 72,
                    //     left: 0,
                    //     right: 0,
                    //     height: 15,
                    //     background: 'linear-gradient(rgba(255, 255, 255, 0.9), transparent)',
                    //     pointerEvents: 'none',
                    //     zIndex: 1
                    // }} />,
                    <ScrollView style={{
                        width: width + 30, height: Commons.getDesktopHeight() - 70,
                        paddingLeft: 15, backgroundColor: AppStyles.desktopBackgroundColor
                    }} showsVerticalScrollIndicator={false}>
                        {/* {Commons.renderAppHeader('', this, '', '', '', this.state.isSearch, '', '', this.state.itemsNo)} */}
                        {
                            <View style={{}}>
                                {Styles.renderVSeparator(0)}
                                {this.renderPart1()}
                                {this.renderPart2()}
                                {this.renderPart3()}
                                {Styles.renderVSeparator(0)}
                                {this.renderPart4()}
                                {Styles.renderVSeparator(40)}
                                {this.renderPart5()}
                                {Styles.renderVSeparator(20)}
                                {this.renderPart6()}

                            </View>
                        }

                    </ScrollView >]

            ]
        );

    }


    renderPart1 = () => {
        let currentArrow = arrowDown;
        if (this.state.showActiveOrder) {
            currentArrow = arrowUp;
        }
        const imgWidth = (width - 55) / 2;
        const imgHeight = imgWidth / 2;
        const offerViews = [];
        const offerPerPage = parseInt(width / imgWidth);
        this.state.advs.forEach((item, index) => {
            if (index % offerPerPage === 0) {
                offerViews.push([]);
            }
            offerViews[offerViews.length - 1].push(
                <TouchableOpacity
                    style={{
                        borderRadius: 24,
                        overflow: 'hidden',
                        backgroundColor: '#fff',
                        elevation: 2,
                        marginRight: 30,
                        width: imgWidth,
                        height: imgHeight,
                        marginTop: 0,
                    }}
                    onPress={() => {
                        if (!item.ITEMS || item.ITEMS.length === 0) {
                            return;
                        }
                        this.setState({ filterID: '', isAdv: true, isAdvProducts: item.ITEMS, showOrderNow: true, allFilters: [], categoryFilter: '', filterName: '' });
                    }}
                >
                    <Image
                        source={{ uri: item.IMGURL }}
                        style={{
                            width: imgWidth,
                            height: imgHeight,
                            borderRadius: 24,
                        }}
                        resizeMode="cover"
                    />
                </TouchableOpacity>
            );
        });

        const lastPage = offerViews[offerViews.length - 1];
        if (lastPage && lastPage.length < offerPerPage) {
            const itemsToAdd = offerPerPage - lastPage.length;
            for (let i = 0; i < itemsToAdd; i++) {
                lastPage.push(
                    <View
                        key={`empty_offer_${i}`}
                        style={{
                            borderRadius: 12,
                            backgroundColor: 'transparent',
                            marginRight: 20,
                            width: imgWidth,
                            height: imgHeight,
                            marginTop: 0,
                        }}
                    />
                );
            }
        }

        return (
            <View style={{ marginHorizontal: 0 }}>
                {/* {
                    this.state.orders.length > 0 && <TouchableOpacity
                        onPress={() => this.setState({ showActiveOrder: !this.state.showActiveOrder })}
                        style={{
                            justifyContent: 'space-between', flexDirection: 'row', alignItems: 'center', alignSelf: 'stretch',
                            borderRadius: 10, borderWidth: 1, borderColor: '#FFF', backgroundColor: '#D6E6D3', width: width - 35, height: 40,
                        }}>
                        <View style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center', gap: 5, marginHorizontal: 16 }}>
                            <Image source={truckIcon} style={{ width: 14.667, height: 11, tintColor: Styles.appColor1 }} />
                            <Text style={[AppStyles.activeOrdersText]}> {STRINGS.Active_Orders}</Text>
                        </View>
                        <TouchableOpacity style={{ marginRight: 16 }}
                            onPress={() => this.setState({ showActiveOrder: !this.state.showActiveOrder })}>
                            <Image source={currentArrow} style={{ width: 9.6, height: 4.8, tintColor: Styles.appColor1 }} />
                        </TouchableOpacity>
                    </TouchableOpacity>
                }
                {this.state.showActiveOrder && } */}
                {this.renderActiveOrderView()}

                <View style={{
                    justifyContent: 'center', alignItems: 'center', width,
                    marginTop: 20,
                    marginLeft: 10
                }}>
                    <Slideshow
                        dataSource={offerViews.map(item => ({
                            url: item.IMGURL + "",
                            view: <View style={{ flexDirection: 'row' }}>{item}</View>
                        }))}
                        height={imgHeight + 40}
                        width={width}
                        imgWidth={imgWidth * 2 + 60}
                        arrowSize={24}
                        indicatorSize={8}
                        indicatorColor={AppStyles.appColor5}
                        indicatorSelectedColor={AppStyles.appColor1}
                        autoPlay={true}
                        autoPlayInterval={3000}
                        arrowRight={<View />}
                        arrowLeft={<View />}
                        scrollEnabled={true}
                        containerStyle={{
                            borderRadius: 12,
                            overflow: 'hidden',
                            alignItems: 'flex-start',
                            backgroundColor: AppStyles.desktopBackgroundColor,
                        }}
                        filterID={this.state.filterID}
                        isAdvProducts={this.state.isAdvProducts}
                    // Add other props as needed
                    />
                </View>
            </View >
        );
    }

    renderActiveOrderView = () => {
        if (!this.state.orders || this.state.orders.length === 0) return null;
        let cardWidth = (width - 48) / 2;
        if (cardWidth > 230) cardWidth = 230;
        const cardScale = cardWidth / 230;
        return (
            [
                <TouchableOpacity
                    onPress={() => {
                        if (this.props.self && !isMobile) {
                            this.props.self.setState({ currentTab: STRINGS.Orders });
                        } else {
                            window.location = './myorders';
                        }
                    }}
                    style={{ flexDirection: 'row', alignItems: 'center', marginLeft: isMobile ? 8 : 16, marginBottom: isMobile ? 0 : 10 }}>
                    <Text style={[AppStyles.LabelTextStyles, { fontSize: 10 }]}>{STRINGS.Orders}</Text>
                    <Image source={rightArrow} style={{ width: 20, height: 20 }} />
                </TouchableOpacity>,
                <ScrollView
                    style={{
                        flexDirection: 'row',
                        marginLeft: isMobile ? 0 : 16,
                    }}
                    horizontal
                    showsHorizontalScrollIndicator={false}
                >
                    {/* Your active order content here */}
                    {this.state.orders.map((order, idx) => (
                        <TouchableOpacity style={{
                            justifyContent: 'space-between', width: 230 * cardScale,
                            alignItems: 'center', flexDirection: 'row', alignSelf: 'stretch',
                            borderRadius: 10, borderWidth: 1, borderColor: '#fff',
                            backgroundColor: '#fff',
                            marginRight: isMobile ? 7 : 16,
                            paddingVertical: 10,
                            paddingHorizontal: 10,
                            shadowColor: '#202020',
                            shadowOffset: { width: 5, height: 5 },
                            shadowOpacity: 0.03,
                            shadowRadius: 15,
                            elevation: 3,
                            marginVertical: 4,
                            marginLeft: 3
                        }}
                            onPress={() => this.setState({
                                showOrderDetails: true, detailsOrderNo: order.ORD_NO,
                                detailsOrderInvoice: order.INV_NO,
                                detailsOrderInvoiceID: order.INV_ID,
                                InvoiceValue: order.VALUE
                            })}
                        >
                            <View style={{ flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start' }}>
                                <Text style={[AppStyles.orderListText, { fontSize: 12 * cardScale, lineHeight: 11 * cardScale * 1.3 }]}>{STRINGS.active_order_id}: {'\n'}{order.ORD_NO}</Text>
                                <Text style={[AppStyles.orderListText, { fontSize: 12 * cardScale, lineHeight: 11 * cardScale * 1.6, color: '#14242E9E' }]}>{STRINGS.estimated_delivery}: {order.EST_DLV}</Text>
                            </View>
                            <View style={{ flexDirection: 'column', alignItems: 'center', gap: 4 }}>
                                <View style={{ width: 14, height: 14, borderRadius: 360, backgroundColor: order.COLOR }}></View>
                                <Text style={[AppStyles.orderShopStatus, { fontSize: 12 * cardScale, lineHeight: 12 * cardScale * 1.6 }]}>{order.STATUS}</Text>
                            </View>
                        </TouchableOpacity>
                    ))}
                </ScrollView>]
        )
    }

    renderPart1Mobile = () => {
        let currentArrow = arrowDown;
        if (this.state.showActiveOrder) {
            currentArrow = arrowUp;
        }

        return (
            <View style={{ gap: 8, flexShrink: 0, alignSelf: 'stretch', marginHorizontal: 16, marginBottom: 20 }}>
                {/* {
                    this.state.orders.length > 0 && <TouchableOpacity
                        onPress={() => this.setState({ showActiveOrder: !this.state.showActiveOrder })}
                        style={{
                            justifyContent: 'space-between', flexDirection: 'row', alignItems: 'center',
                            alignSelf: 'stretch', borderRadius: 10, borderWidth: 1, borderColor: '#FFF', backgroundColor: '#D6E6D3', width: width - 30, height: 40,
                            marginTop: 12
                        }}>
                        <View style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center', gap: 5, marginHorizontal: 16 }}>
                            <Image source={truckIcon} style={{ width: 14.667, height: 11, tintColor: Styles.appColor1 }} />
                            <Text style={[AppStyles.activeOrdersText]}> {STRINGS.Active_Orders}</Text>
                        </View>
                        <TouchableOpacity style={{ marginRight: 16 }}
                            onPress={() => this.setState({ showActiveOrder: !this.state.showActiveOrder })}>
                            <Image source={currentArrow} style={{ width: 9.6, height: 4.8, tintColor: Styles.appColor1 }} />
                        </TouchableOpacity>
                    </TouchableOpacity>
                } */}
                {this.renderActiveOrderView()}
                <View style={{ justifyContent: 'center', alignItems: 'center', width: width - 25, marginTop: 16, marginBottom: 25 }}>
                    <Slideshow
                        dataSource={this.state.advs.map(item => ({
                            url: item.IMGURL,
                            // You can add title/caption if needed
                        }))}
                        arrowSize={24}
                        indicatorSize={8}
                        indicatorBelow={true}
                        imgWidth={width - 30}
                        width={width - 30}
                        height={(width - 30) / 2}
                        indicatorColor={AppStyles.appColor5}
                        indicatorSelectedColor={AppStyles.appColor1}
                        autoPlay={true}
                        autoPlayInterval={3000}
                        arrowRight={<View />}
                        arrowLeft={<View />}
                        scrollEnabled={true}
                        containerStyle={{
                            borderRadius: 12,
                            overflow: 'hidden',
                        }}
                        filterID={this.state.filterID}
                        isAdvProducts={this.state.isAdvProducts}
                        showOrderNow={(show) => {
                            this.setState({
                                showOrderNow: show, filterID: '', isAdv: show,
                                featuredItems: this.state.featuredItems.slice(), bestSellers: this.state.bestSellers.slice()
                            });

                        }}
                        onTouch={(index) => {
                            const item = this.state.advs[index];
                            if (!item.ITEMS || item.ITEMS.length === 0) {
                                return;
                            }
                            this.setState({ filterID: '', isAdv: true, isAdvProducts: item.ITEMS, showOrderNow: true, allFilters: [], categoryFilter: '', filterName: '' });
                        }}
                    // Add other props as needed
                    />
                </View>
            </View>
        );
    }

    renderBrandItem = ({ item }) => {
        return (item);
    }



    renderCousumerBrands = () => {
        return (
            <View style={{ display: 'flex', width: width, height: 200, flexDirection: 'column' }}>
                <View style={{ flexDirection: "row", gap: 10, alignItems: "center", justifyContent: "center" }}>
                    {this.state.consumerBrands.map((item, index) =>
                        index >= 0 && index <= 4 && (
                            <TouchableOpacity style={{
                                display: 'flex',
                                height: 67.998, width: 67.998, backgroundColor: 'rgba(238, 238, 238, 0.46)', margin: 4.89, borderRadius: 3.4, alignItems: 'center', justifyContent: 'center'
                            }}>
                                <Image source={{ uri: item.IMG }} style={{ width: 52.698, height: 27.541 }} resizeMode="contain" />
                                <Text style={[AppStyles.categTextStyle, { position: 'absolute', bottom: 7.2 }]}> {item.NAME}</Text>
                            </TouchableOpacity>
                        )
                    )}
                </View>
                <View style={{ flexDirection: "row", gap: 10, alignItems: "center", justifyContent: "center" }}>
                    {this.state.consumerBrands.map((item, index) =>
                        index >= 5 && index <= 9 && (
                            <TouchableOpacity style={{
                                display: 'flex', height: 67.998,
                                width: 67.998, backgroundColor: 'rgba(238, 238, 238, 0.46)', margin: 4.89, borderRadius: 3.4, alignItems: 'center', justifyContent: 'center'
                            }}>
                                <Image source={{ uri: item.IMG }} style={{ width: 52.698, height: 27.541 }} resizeMode="contain" />
                                <Text style={[AppStyles.categTextStyle, { position: 'absolute', bottom: 7.2 }]}> {item.NAME}</Text>
                            </TouchableOpacity>
                        )
                    )}
                </View>
            </View>
        )
    };

    renderOtherPart2Mobile = () => {
        const chunkArray = (arr, size) => {
            const result = [];
            for (let i = 0; i < arr.length; i += size) {
                result.push(arr.slice(i, i + size));
            }
            return result;
        };

        // Split into 3 rows
        let itemsPerRow = Math.ceil(this.state.consumerBrands.length / 1);
        let brandRows = chunkArray(this.state.consumerBrands, itemsPerRow);
        return (
            <View style={{ display: 'flex', alignSelf: 'stretch', flexDirection: 'column', gap: 9.771, marginHorizontal: 16, width: 555, opacity: 0.3 }}>
                <View>
                    <Text style={[AppStyles.appTitleStyle]}>{STRINGS.app_Brands}</Text>
                </View>
                <ScrollView
                    horizontal
                    showsHorizontalScrollIndicator={false}
                    contentContainerStyle={{ flexDirection: 'column', gap: 1 }}
                    style={{ width: width - 20 }}
                >
                    {brandRows.map((row, rowIdx) => (
                        <View
                            key={rowIdx}
                            style={{
                                flexDirection: 'row',
                                justifyContent: 'flex-start',
                                gap: 1,
                            }}
                        >
                            {row.map((item, idx) => (
                                <TouchableOpacity
                                    key={idx}
                                    style={{
                                        display: 'flex',
                                        height: 40.998,
                                        width: 70.998,
                                        backgroundColor: 'rgba(238, 238, 238, 0.46)',
                                        margin: 4.89,
                                        borderRadius: 3.4,
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                    onPress={() => {

                                    }}
                                >
                                    <Image source={{ uri: item.IMG }} style={{ width: 52.698, height: 27.541 }} resizeMode="contain" />
                                </TouchableOpacity>
                            ))}
                        </View>
                    ))}
                </ScrollView>
            </View>
        );
    }

    renderPart2 = () => {
        return (
            <View style={{
                display: 'flex', alignSelf: 'stretch', flexDirection: 'column',
                gap: 9.771, marginHorizontal: 16, width: 555, opacity: this.state.isOther ? 0.3 : 1, marginTop: 0
            }}>
                <View>
                    <Text style={[AppStyles.appTitleStyle]}>{STRINGS.shop_by_brand}</Text>
                </View>
                <ScrollView
                    horizontal
                    showsHorizontalScrollIndicator={false}
                    contentContainerStyle={{ flexDirection: 'row', alignItems: 'flex-start', gap: 30, marginRight: 20 }}
                    style={{ width, marginTop: 20 }}
                >
                    {this.state.consumerBrands.map((item, idx) => (
                        <View key={idx} style={{
                            alignItems: 'center', justifyContent: 'center', marginHorizontal: 4
                        }}>
                            <TouchableOpacity
                                style={{
                                    display: 'flex',
                                    height: isMobile ? 50.998 : 96,
                                    width: isMobile ? 70.998 : 103,
                                    backgroundColor: 'white',
                                    borderRadius: 20,
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    // Cross-platform shadow
                                    shadowColor: '#202020',
                                    shadowOffset: { width: 5, height: 5 },
                                    shadowOpacity: 0.03,
                                    shadowRadius: 15,
                                    elevation: 3
                                }}
                                onPress={() => {
                                    filterName.push(item.ENNAME);
                                    this.setState({ showOrderNow: true, filterID: item.ID, filterName, allFilters: [item.ID] });
                                }}
                            >

                                <Image source={{ uri: item.IMG }} style={{ width: isMobile ? 56.698 : 86, height: isMobile ? 52.541 : 90 }} resizeMode="contain" />
                            </TouchableOpacity>
                            <Text style={[AppStyles.brandName, { marginTop: 15, textAlign: 'center' }]}>{item.ENNAME}</Text>
                        </View>
                    ))}
                </ScrollView>
            </View>
        );
    }

    renderPart2Mobile = () => {
        const chunkArray = (arr, size) => {
            const result = [];
            for (let i = 0; i < arr.length; i += size) {
                result.push(arr.slice(i, i + size));
            }
            return result;
        };

        // Split into 2 rows for desktop, 3 rows for mobile
        const rowCount = isMobile ? 2 : 2;
        let itemsPerRow = Math.ceil(this.state.consumerBrands.length / rowCount);
        let brandRows = chunkArray(this.state.consumerBrands, itemsPerRow);
        var opacity = 1;
        if (this.state.isOther) {
            opacity = 0.3;
        }
        return (
            <View style={{ display: 'flex', alignSelf: 'stretch', flexDirection: 'column', gap: 9.771, marginHorizontal: 16, width: 555, opacity }}>
                <View>
                    <Text style={[AppStyles.appTitleStyle]}>{STRINGS.shop_by_brand}</Text>
                </View>
                <ScrollView
                    horizontal
                    showsHorizontalScrollIndicator={false}
                    contentContainerStyle={{ flexDirection: 'column', gap: 1 }}
                    style={{ width: width - 20, marginTop: 10 }}
                >
                    {brandRows.map((row, rowIdx) => (
                        <View
                            key={rowIdx}
                            style={{
                                flexDirection: 'row',
                                justifyContent: 'flex-start',
                                gap: 1,
                            }}
                        >
                            {row.map((item, idx) => {
                                // Find image from imagesList by item.ID
                                // const imgObj = imagesList.find(img => img.EN_NAME === item.EN_NAME);
                                const imgObj = '';
                                return (
                                    <TouchableOpacity
                                        key={idx}
                                        style={{
                                            display: 'flex',
                                            height: isMobile ? 60.998 : 55.998 * scale,
                                            width: isMobile ? 65.998 : 80 * scale,
                                            backgroundColor: '#fff',
                                            margin: 7,
                                            marginLeft: idx === 0 ? 0 : 7,
                                            borderRadius: 12,
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            // Cross-platform shadow
                                            shadowColor: '#202020',
                                            shadowOffset: { width: 5, height: 5 },
                                            shadowOpacity: 0.05,
                                            shadowRadius: 15,
                                            elevation: 1,
                                            marginLeft: 2,
                                        }}
                                        onPress={() => {
                                            filterName.push(item.ENNAME);
                                            this.setState({ showOrderNow: true, filterID: item.ID, filterName, allFilters: [item.ID] })
                                            // if (!isMobile) {
                                            //     this.props.self.setState({ style: { opacity: 0.5 } });
                                            // }
                                        }}
                                    >
                                        <Image source={{ uri: imgObj ? imgObj.IMG : item.IMG }} style={{ width: isMobile ? 56.698 : 56.698 * scale, height: isMobile ? 52.541 : 52.541 * scale }} resizeMode="contain" />
                                    </TouchableOpacity>
                                )
                            })}
                        </View>
                    ))}
                </ScrollView>
            </View>
        );
    }


    renderPart3 = () => {
        const offerViews = [];
        const imgWidth = (width - 55) / 3;
        const imgHeight = imgWidth / 2;
        const offerPerPage = parseInt(width / imgWidth);
        this.state.offers.forEach((item, index) => {
            if (index % offerPerPage === 0) {
                offerViews.push([]);
            }
            offerViews[offerViews.length - 1].push(
                <TouchableOpacity
                    style={{
                        borderRadius: 12,
                        overflow: 'hidden',
                        backgroundColor: '#fff',
                        elevation: 2,
                        marginRight: 20,
                        width: imgWidth,
                        height: imgHeight,
                        marginTop: 0,
                    }}
                    onPress={() => {
                        if (item.ITEM_NO !== '') {
                            this.setState({ showProductsDetails: true, productID: item.ITEM_NO });
                        }
                    }}
                >
                    <Image source={{ uri: item.BRAND_IMG }} style={{
                        position: 'absolute', top: 16, left: 16, width: 50, height: 50, zIndex: 1,
                        backgroundColor: AppStyles.desktopBackgroundColor, paddingHorizontal: 5, paddingVertical: 18,
                        borderRadius: 13
                    }} resizeMode="contain" />
                    <Image
                        source={{ uri: item.IMG }}
                        style={{
                            width: imgWidth,
                            height: imgHeight,
                            borderRadius: 12.887,
                        }}
                        resizeMode="cover"
                    />
                </TouchableOpacity>
            );
        });
        const lastPage = offerViews[offerViews.length - 1];
        if (lastPage && lastPage.length < offerPerPage) {
            const itemsToAdd = offerPerPage - lastPage.length;
            for (let i = 0; i < itemsToAdd; i++) {
                lastPage.push(
                    <View
                        key={`empty_offer_${i}`}
                        style={{
                            borderRadius: 12,
                            backgroundColor: 'transparent',
                            marginRight: 20,
                            width: imgWidth,
                            height: imgHeight,
                            marginTop: 0,
                        }}
                    />
                );
            }
        }
        return (
            <View style={{ marginTop: 40, marginHorizontal: 16 }}>
                <View style={{}}>
                    <TouchableOpacity
                        style={{
                            width: width - 30,
                            marginVertical: 10,
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                        onPress={() => {
                            this.setState({ filterID: '', isOffers: true, showOrderNow: true });
                        }}>
                        <Text style={[AppStyles.appTitleStyle]}>{STRINGS.appOffers}</Text>
                        {/* <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                            <Text style={[AppStyles.LabelTextStyles, { fontSize: 16 }]}>{STRINGS.view_all}</Text>
                            <Image source={rightArrow} style={{ width: 20, height: 20 }} />
                        </View> */}
                    </TouchableOpacity>


                    <View style={{ justifyContent: 'center', alignItems: 'center', width: width - 40, marginLeft: 15, marginTop: 16 }}>
                        <Slideshow
                            dataSource={offerViews.map(item => ({
                                url: item.IMGURL + "",
                                view: <View style={{ flexDirection: 'row' }}>{item}</View>
                            }))}
                            height={imgHeight + 40}
                            width={width}
                            imgWidth={imgWidth * 3 + 60}
                            arrowSize={24}
                            indicatorSize={8}
                            indicatorColor={AppStyles.appColor5}
                            indicatorSelectedColor={AppStyles.appColor1}
                            autoPlay={false}
                            autoPlayInterval={3000}
                            arrowRight={<View />}
                            arrowLeft={<View />}
                            scrollEnabled={true}
                            containerStyle={{
                                borderRadius: 12,
                                overflow: 'hidden',
                                alignItems: 'flex-start',
                                backgroundColor: AppStyles.desktopBackgroundColor,
                            }}
                            filterID={this.state.filterID}
                            isAdvProducts={this.state.isAdvProducts}
                            showOrderNow={(show) => {
                                this.setState({
                                    showOrderNow: show, filterID: '', isAdv: show,
                                    featuredItems: this.state.featuredItems.slice(), bestSellers: this.state.bestSellers.slice()
                                });

                            }}
                            onTouch={(index) => {
                                const item = this.state.advs[index];
                                if (!item.ITEMS || item.ITEMS.length === 0) {
                                    return;
                                }
                                this.setState({ filterID: '', isAdv: true, isAdvProducts: item.ITEMS, showOrderNow: true, allFilters: [], categoryFilter: '', filterName: '' });
                            }}
                        // Add other props as needed
                        />
                    </View>
                </View>

            </View>
        );
    }



    renderPart3Mobile = () => {
        const offerViews = [];
        const imgWidth = (width - 90) / 1;
        const imgHeight = imgWidth / 2;
        const offerPerPage = parseInt(width / imgWidth);
        this.state.offers.forEach((item, index) => {
            if (index % offerPerPage === 0) {
                offerViews.push([]);
            }
            offerViews[offerViews.length - 1].push(
                <TouchableOpacity
                    style={{
                        borderRadius: 12,
                        overflow: 'hidden',
                        backgroundColor: '#fff',
                        marginRight: 10,
                        width: imgWidth,
                        height: imgHeight,
                        marginTop: 0,
                        marginRight: index === this.state.offers.length - 1 ? 26 : 16
                    }}
                    onPress={() => {
                        if (item.ITEM_NO !== '') {
                            this.setState({ showProductsDetails: true, productID: item.ITEM_NO });
                        }
                    }}
                >
                    <Image source={{ uri: item.BRAND_IMG }} style={{
                        position: 'absolute', top: 16, left: 16, width: 40, height: 40, zIndex: 1,
                        backgroundColor: AppStyles.desktopBackgroundColor, paddingHorizontal: 5, paddingVertical: 18,
                        borderRadius: 13
                    }} resizeMode="contain" />
                    <Image
                        source={{ uri: item.IMG }}
                        style={{
                            width: imgWidth,
                            height: imgHeight,
                            borderRadius: 12.887,
                        }}
                        resizeMode="cover"
                    />
                </TouchableOpacity>
            );
        });
        // const lastPage = offerViews[offerViews.length - 1];
        // if (lastPage && lastPage.length < offerPerPage) {
        //     const itemsToAdd = offerPerPage - lastPage.length;
        //     for (let i = 0; i < itemsToAdd; i++) {
        //         lastPage.push(
        //             <View
        //                 key={`empty_offer_${i}`}
        //                 style={{
        //                     borderRadius: 12,
        //                     backgroundColor: 'transparent',
        //                     marginRight: 10,
        //                     width: imgWidth,
        //                     height: imgHeight,
        //                     marginTop: 0,
        //                 }}
        //             />
        //         );
        //     }
        // }
        return (
            <View style={{ marginTop: 10 }}>
                <View style={{}}>
                    <TouchableOpacity
                        style={{
                            width: width - 30,
                            marginVertical: 10,
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            marginHorizontal: 20
                        }}
                        onPress={() => {
                            this.setState({ filterID: '', isOffers: true, showOrderNow: true });
                        }}>
                        <Text style={[AppStyles.appTitleStyle]}>{STRINGS.appOffers}</Text>
                        {/* <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                            <Text style={[AppStyles.LabelTextStyles, { fontSize: 16 }]}>{STRINGS.view_all}</Text>
                            <Image source={rightArrow} style={{ width: 20, height: 20 }} />
                        </View> */}
                    </TouchableOpacity>


                    <View style={{ justifyContent: 'center', alignItems: 'center', width: width - 40, marginTop: 16, marginHorizontal: 30 }}>
                        <Slideshow
                            dataSource={offerViews.map(item => ({
                                url: item.IMGURL + "",
                                view: <View style={{ flexDirection: 'row' }}>{item}</View>
                            }))}
                            height={imgHeight + 20}
                            width={width}
                            imgWidth={imgWidth * 1 + 30}
                            arrowSize={24}
                            indicatorSize={0}
                            indicatorColor={AppStyles.appColor5}
                            indicatorSelectedColor={AppStyles.appColor1}
                            autoPlay={false}
                            autoPlayInterval={3000}
                            arrowRight={<View />}
                            arrowLeft={<View />}
                            scrollEnabled={true}
                            containerStyle={{
                                borderRadius: 12,
                                overflow: 'hidden',
                                alignItems: 'flex-start',
                                backgroundColor: AppStyles.desktopBackgroundColor,
                            }}
                            filterID={this.state.filterID}
                            isAdvProducts={this.state.isAdvProducts}
                            showOrderNow={(show) => {
                                this.setState({
                                    showOrderNow: show, filterID: '', isAdv: show,
                                    featuredItems: this.state.featuredItems.slice(), bestSellers: this.state.bestSellers.slice()
                                });

                            }}
                            onTouch={(index) => {
                                const item = this.state.advs[index];
                                if (!item.ITEMS || item.ITEMS.length === 0) {
                                    return;
                                }
                                this.setState({ filterID: '', isAdv: true, isAdvProducts: item.ITEMS, showOrderNow: true, allFilters: [], categoryFilter: '', filterName: '' });
                            }}
                        // Add other props as needed
                        />
                    </View>
                </View>

            </View>
        );
    }

    renderPart4 = () => {
        // Split categories into 2 rows for horizontal scroll
        const chunkArray = (arr, size) => {
            const result = [];
            for (let i = 0; i < arr.length; i += size) {
                result.push(arr.slice(i, i + size));
            }
            return result;
        };

        const rowCount = 1;
        const itemsPerRow = Math.ceil(this.state.categories.length / rowCount);
        const categoryRows = chunkArray(this.state.categories, itemsPerRow);
        scale = width / 1200;
        if (scale > 1) scale = 1;
        return (
            <View style={{ display: 'flex', alignSelf: 'stretch', flexDirection: 'column', gap: 9.771, }}>
                <View style={{ marginHorizontal: 16 }}>
                    <Text style={[AppStyles.appTitleStyle, { marginBottom: 10 }]}>{STRINGS.shop_by_category}</Text>
                </View>
                <View
                    horizontal
                    showsHorizontalScrollIndicator={false}
                    contentContainerStyle={{ flexDirection: 'column', gap: 1 }}
                    style={{ width }}
                >
                    {categoryRows.map((row, rowIdx) => (
                        <View
                            key={rowIdx}
                            style={{
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                gap: 1,
                                marginLeft: 6
                            }}
                        >
                            {row.map((item, idx) => (
                                <TouchableOpacity
                                    key={idx}
                                    style={{
                                        display: 'flex',
                                        minWidth: 85.174,
                                        borderRadius: 8.949,
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        flexDirection: 'column',
                                        gap: 12,
                                        margin: 4.89,
                                        marginHorizontal: 3,
                                    }}
                                    onPress={() => {
                                        filterName.push(item.ENNAME);
                                        this.setState({ showOrderNow: true, categoryFilter: item.ID, filterName, allFilters: [item.ID] });
                                        // if (!isMobile) {
                                        //     this.props.self.setState({ style: { opacity: 0.5 } });
                                        // }
                                    }}
                                >
                                    <View style={{
                                        height: 113.751 * scale,
                                        width: 113.751 * scale,
                                        backgroundColor: 'white',
                                        borderRadius: 10,
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        // Cross-platform shadow
                                        shadowColor: '#202020',
                                        shadowOffset: { width: 5, height: 5 },
                                        shadowOpacity: 0.03,
                                        shadowRadius: 15,
                                        elevation: 2
                                    }}>
                                        <Image source={{ uri: item.IMG }} style={{ width: 76 * scale, height: 86.68 * scale }} resizeMode="contain" />
                                    </View>
                                    <Text style={[AppStyles.categoriesText, { fontSize: 16 * scale }]}> {item.ENNAME}</Text>
                                </TouchableOpacity>
                            ))}
                        </View>
                    ))}
                </View>
            </View>
        )
    }

    renderPart4Mobile = () => {
        // Split categories into 2 rows for horizontal scroll
        const chunkArray = (arr, size) => {
            const result = [];
            for (let i = 0; i < arr.length; i += size) {
                result.push(arr.slice(i, i + size));
            }
            return result;
        };

        const rowCount = isMobile ? 2 : 1;
        const itemsPerRow = Math.ceil(this.state.categories.length / rowCount);
        const categoryRows = chunkArray(this.state.categories, itemsPerRow);
        return (
            <View style={{ display: 'flex', alignSelf: 'stretch', flexDirection: 'column', gap: 9.771, marginTop: 10 }}>
                <View style={{ marginHorizontal: 20 }}>
                    <Text style={[AppStyles.appTitleStyle, { marginBottom: 10 }]}>{STRINGS.shop_by_category}</Text>
                </View>
                <ScrollView
                    horizontal
                    showsHorizontalScrollIndicator={false}
                    contentContainerStyle={{ flexDirection: 'column', gap: 1 }}
                    style={{ gap: 1, marginLeft: 16 }}
                >
                    {categoryRows.map((row, rowIdx) => (
                        <View
                            key={rowIdx}
                            style={{
                                flexDirection: 'row',
                                justifyContent: 'space-around',
                                gap: 1,

                            }}
                        >
                            {row.map((item, idx) => (
                                <TouchableOpacity
                                    key={idx}
                                    style={{
                                        display: 'flex',
                                        height: isMobile ? 74.41 : 150.751,
                                        minWidth: 104.41,
                                        minHeight: 104.41,
                                        borderRadius: 8.949,
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        flexDirection: 'column',
                                        gap: 10,
                                        marginHorizontal: 4,
                                    }}
                                    onPress={() => {
                                        filterName.push(item.ENNAME);
                                        this.setState({ showOrderNow: true, categoryFilter: item.ID, filterName, allFilters: [item.ID] });
                                        // if (!isMobile) {
                                        //     this.props.self.setState({ style: { opacity: 0.5 } });
                                        // }
                                    }}
                                >
                                    <Image source={{ uri: item.IMG }} style={{ width: isMobile ? 60 : 100.77, height: isMobile ? 60 : 86.68 }} resizeMode="contain" />
                                    <Text style={[AppStyles.categoriesText, { position: 'absolute', bottom: 7.2, fontSize: 11 }]}> {item.ENNAME}</Text>
                                </TouchableOpacity>
                            ))}
                            {Styles.renderSeparator(16)}
                        </View>
                    ))}
                </ScrollView>
            </View>
        )
    }

    renderPart5 = () => {
        const numColumns = Commons.getNumColumns();
        return (
            <View style={{ marginTop: 10 }}>
                <TouchableOpacity style={{
                    width: width - 30,
                    flexDirection: 'row', marginVertical: 10, alignItems: 'center', justifyContent: 'space-between',
                    marginHorizontal: 16
                }}
                    onPress={() => {
                        this.setState({ showOrderNow: true, isFeatured: true });
                        // if (!isMobile) {
                        //     this.props.self.setState({ style: { opacity: 0.5 } });
                        // }
                    }}>
                    <Text style={[AppStyles.appTitleStyle, {}]}>{STRINGS.appFeatured}</Text>
                    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                        <Text style={[AppStyles.LabelTextStyles, { fontSize: 16 }]}>{STRINGS.view_all}</Text>
                        <Image source={rightArrow} style={{ width: 20, height: 20 }} />
                    </View>
                </TouchableOpacity>
                <View style={{
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    width: width - 16,
                    marginLeft: 13
                }}>
                    {this.state.featuredItems.slice(0, numColumns).map((item, index) => this.renderFeaturedItem(item))}
                </View>

            </View>
        )
    }

    renderPart6 = () => {
        const numColumns = Commons.getNumColumns();
        return (
            <View style={{ marginTop: 10 }}>
                <TouchableOpacity style={{
                    width: width - 30,
                    flexDirection: 'row', marginVertical: 5, alignItems: 'center', justifyContent: 'space-between'
                }}
                    onPress={() => {
                        this.setState({ showOrderNow: true, isBestSellers: true });
                        // this.props.self.setState({ style: { opacity: 0.5 } });
                    }}>
                    <Text style={[AppStyles.appTitleStyle, { marginHorizontal: 16 }]}>{STRINGS.app_Best_Sellers}</Text>
                    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                        <Text style={[AppStyles.LabelTextStyles, { fontSize: 16 }]}>{STRINGS.view_all}</Text>
                        <Image source={rightArrow} style={{ width: 20, height: 20 }} />
                    </View>
                </TouchableOpacity>
                <View style={{
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    width: width - 16,
                    marginLeft: 13
                }}>
                    {this.state.bestSellers.slice(0, numColumns).map((item, index) => this.renderFeaturedItem(item))}
                </View>
            </View>
        );

    }

    renderPart5Mobile = () => {

        return (
            <View style={{ marginTop: 20, marginHorizontal: 20 }}>
                <TouchableOpacity style={{ width: width - 40, flexDirection: 'row', marginVertical: 10, alignItems: 'center', justifyContent: 'space-between' }}
                    onPress={() => {
                        this.setState({ showOrderNow: true, isFeatured: true });
                        // if (!isMobile) {
                        //     this.props.self.setState({ style: { opacity: 0.5 } });
                        // }
                    }}>
                    <Text style={[AppStyles.appTitleStyle, {}]}>{STRINGS.appFeatured}</Text>
                    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                        <Text style={[AppStyles.LabelTextStyles, { fontSize: 16 }]}>{STRINGS.view_all}</Text>
                        <Image source={rightArrow} style={{ width: 20, height: 20 }} />
                    </View>
                </TouchableOpacity>
                <FlatList
                    horizontal
                    showsHorizontalScrollIndicator={false}
                    style={{ marginTop: 0 }}
                    contentContainerStyle={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: 16,
                        alignSelf: 'stretch',
                        flexDirection: 'row',
                    }}
                    ref={ref => (this.scrollViewRefFeatured = ref)}
                    data={this.state.featuredItems}
                    keyExtractor={item => item.ID}
                    renderItem={({ item }) => this.renderFeaturedItem(item)}
                />
            </View>
        )
    }

    // setFeaturedQty = (qty) => {
    // this.setState({ featuredQty: qty });
    // }

    renderBonusDetails = (item) => {
        return (
            <View style={{
                position: 'absolute',
                top: 0,
                left: 0,
                // backgroundColor: '#6BA461',
                borderTopLeftRadius: 5,
                borderBottomRightRadius: 5,
                paddingVertical: 2,
                zIndex: 10,
                width: 55.857,
                height: 23,
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'row',
                gap: 2.5,
            }}>
                {this.state.orderResponse && (
                    (() => {
                        const existed = this.state.orderResponse.find(existed => existed.ID === item.ID);
                        if (existed) {
                            if (existed.BONUS !== '' && existed.NEXT_BONUS > 0 && existed.NEXT_BONUS_TEXT !== '') {
                                return (
                                    <View style={{ width: 55.857, height: 23, borderTopLeftRadius: 5, borderBottomRightRadius: 5, backgroundColor: '#F28C80', position: 'absolute', left: 0, top: 0, justifyContent: 'center', alignItems: 'center' }}>
                                        <Text style={[AppStyles.bonusSearchText]}>
                                            Bonus {existed.NEXT_BONUS_TEXT}
                                        </Text>
                                    </View>
                                );
                            }
                            if (existed.NEXT_BONUS_TEXT === '' && existed.BONUS !== '') {
                                return (
                                    <View style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        backgroundColor: '#6BA461',
                                        borderTopLeftRadius: 5,
                                        borderBottomRightRadius: 5,
                                        paddingVertical: 2,
                                        zIndex: 10,
                                        width: 55.857,
                                        height: 23,
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        flexDirection: 'row',
                                        gap: 2.5,
                                    }}>
                                        <Image source={giftIcon} style={{ height: 10, width: 10 }}></Image>
                                        <Text style={[AppStyles.bonusSearchText]}>+ {existed.BONUS}</Text>
                                    </View>
                                )
                            }

                        } else {
                            if (item.NEXT_BONUS_TEXT !== '') {
                                return (
                                    <View style={{ width: 55.857, height: 23, borderTopLeftRadius: 5, borderBottomRightRadius: 5, backgroundColor: '#F28C80', position: 'absolute', left: 0, top: 0, justifyContent: 'center', alignItems: 'center' }}>
                                        <Text style={[AppStyles.bonusSearchText]}>
                                            Bonus {item.NEXT_BONUS_TEXT}
                                        </Text>
                                    </View>
                                );
                            }

                        }

                    })()
                )}
                {this.state.updatedItem && Object.keys(this.state.updatedItem).length > 0 && this.state.updatedItem.ID === item.ID && (
                    (() => {
                        // const item = this.state.updatedItem;
                        if (this.state.updatedItem.NEXT_BONUS_TEXT !== '' && this.state.updatedItem.BONUS !== '' && this.state.updatedItem.NEXT_BONUS > 0) {
                            return (
                                <View style={{ width: 55.857, height: 23, borderTopLeftRadius: 5, borderBottomRightRadius: 5, backgroundColor: '#F28C80', position: 'absolute', left: 0, top: 0, justifyContent: 'center', alignItems: 'center' }}>
                                    <Text style={[AppStyles.bonusSearchText]}>
                                        Bonus {this.state.updatedItem.NEXT_BONUS_TEXT}
                                    </Text>
                                </View>
                            )
                        }

                        if (this.state.updatedItem.NEXT_BONUS_TEXT === '' && this.state.updatedItem.BONUS !== '') {
                            return (
                                <View style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    backgroundColor: '#6BA461',
                                    borderTopLeftRadius: 5,
                                    borderBottomRightRadius: 5,
                                    paddingVertical: 2,
                                    zIndex: 10,
                                    width: 55.857,
                                    height: 23,
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    flexDirection: 'row',
                                    gap: 2.5,
                                }}>
                                    <Image source={giftIcon} style={{ height: 10, width: 10 }}></Image>
                                    <Text style={[AppStyles.bonusSearchText]}>+ {this.state.updatedItem.BONUS}</Text>
                                </View>
                            )
                        }
                        this.setState({ updatedItem: [] });

                    })()
                )}
            </View>
        )
    }


    renderPart6Mobile = () => {
        return (
            <View style={{ marginTop: 10, marginHorizontal: 20 }}>
                <TouchableOpacity style={{ width: width - 40, flexDirection: 'row', marginVertical: 5, alignItems: 'center', justifyContent: 'space-between' }}
                    onPress={() => {
                        this.setState({ showOrderNow: true, isBestSellers: true });
                        // this.props.self.setState({ style: { opacity: 0.5 } });
                    }}>
                    <Text style={[AppStyles.appTitleStyle, {}]}>{STRINGS.app_Best_Sellers}</Text>
                    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                        <Text style={[AppStyles.LabelTextStyles, { fontSize: 16 }]}>{STRINGS.view_all}</Text>
                        <Image source={rightArrow} style={{ width: 20, height: 20 }} />
                    </View>
                </TouchableOpacity>
                <FlatList
                    horizontal
                    showsHorizontalScrollIndicator={false}
                    style={{ marginTop: 0 }}
                    contentContainerStyle={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: 16,
                        alignSelf: 'stretch',
                        flexDirection: 'row'
                    }}
                    ref={ref => (this.scrollViewRefFeatured = ref)}
                    data={this.state.bestSellers}
                    keyExtractor={item => item.ID}
                    renderItem={({ item }) => this.renderFeaturedItem(item)}
                />
            </View>
        );

    }
    renderPart7Mobile = () => {

    }

    renderOtherTab = () => {

    }



    styles = () => ({
        container: {
            flex: 1,
            backgroundColor: AppStyles.desktopBackgroundColor,
        },
        image: {
            flex: 1,
            resizeMode: 'contain',
            justifyContent: 'center',
            width,
            height: 590,
        }
    });
}



export default Shop;
